import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { MapPin, Mail, Phone } from "lucide-react";

const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="bg-navy text-white mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <div className="w-9 h-9 rounded-xl bg-coral flex items-center justify-center text-white font-bold">CE</div>
            <span className="font-heading font-extrabold text-lg tracking-tight">CALETA EATS</span>
          </div>
          <p className="text-white/70 text-sm leading-relaxed">{t("slogan")}</p>
          <p className="text-white/50 text-xs mt-4 flex items-center gap-1"><MapPin className="w-3 h-3" /> Caleta de Fuste, Fuerteventura</p>
        </div>
        <div>
          <h4 className="font-heading font-bold mb-3">Explore</h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/restaurants" className="hover:text-coral">{t("restaurants")}</Link></li>
            <li><Link to="/categories" className="hover:text-coral">{t("categories")}</Link></li>
            <li><Link to="/family-deals" className="hover:text-coral">{t("familyDeals")}</Link></li>
            <li><Link to="/how-it-works" className="hover:text-coral">{t("howItWorks")}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading font-bold mb-3">Support</h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/help" className="hover:text-coral">{t("help")}</Link></li>
            <li><Link to="/partner" className="hover:text-coral">Partner with us</Link></li>
            <li><Link to="/restaurant-admin/login" className="hover:text-coral">Restaurant sign in</Link></li>
            <li><Link to="/rider/login" className="hover:text-coral">Rider sign in</Link></li>
            <li><Link to="/terms" className="hover:text-coral">Terms & Conditions</Link></li>
            <li><Link to="/privacy" className="hover:text-coral">Privacy Policy</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading font-bold mb-3">Contact (Demo)</h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li className="flex items-center gap-2"><Mail className="w-3 h-3" /> hello@caletaeats.demo</li>
            <li className="flex items-center gap-2"><Phone className="w-3 h-3" /> +34 000 000 000</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-white/40">
        © {new Date().getFullYear()} Caleta Eats — Demo build. All content is placeholder.
      </div>
    </footer>
  );
};

export default Footer;
